export enum CookieDataTypes {
  Marketing = 'Marketing',
  Performance = 'Performance',
}
